import React, { useState, useEffect } from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/weatherOutlook.scss";

// Bootstrap Components
import Container from "react-bootstrap/Container";

// Weather Icon
import "../../../../resources/weather-icons/weather-icons.css";
import { RiArrowRightUpLine, RiArrowRightDownLine } from "react-icons/ri";

import { getWeatherOutlook } from "../../../service/apiHKOWeatherInfoService";

type weatherOutlookArrayItem = {
  outlookID: number;
  outlookMonth: string;
  outlookDay: string;
  outlookWeek: string;
  outlookMaxTemp: number;
  outlookMinTemp: number;
  outlookMaxHum: number;
  outlookMinHum: number;
  outlookWeather: string;
  outlookWind: string;
  outlookPSR: string;
};

//#region UI compoents
function WeatherIcon(ID: number) {
  // ID of weather icons: https://www.hko.gov.hk/textonly/v2/explain/wxicon_e.htm
  switch (ID) {
    case 50:
      return <i className="wo_icons wi wi-day-sunny" />;
    case 51:
      return <i className="wo_icons wi wi-day-sunny-overcast" />;
    case 52:
      return <i className="wo_icons wi wi-day-cloudy" />;
    case 53:
      return <i className="wo_icons wi wi-day-sprinkle" />;
    case 54:
      return <i className="wo_icons wi wi-day-rain" />;
    case 60:
      return <i className="wo_icons wi wi-cloud" />;
    case 61:
      return <i className="wo_icons wi wi-cloudy" />;
    case 62:
      return <i className="wo_icons wi wi-sprinkle" />;
    case 63:
      return <i className="wo_icons wi wi-showers" />;
    case 64:
      return <i className="wo_icons wi wi-rain" />;
    case 65:
      return <i className="wo_icons wi wi-thunderstorm" />;
    case 70:
      return <i className="wo_icons wi wi-moon-new" />;
    case 71:
      return <i className="wo_icons wi wi-moon-waxing-crescent-3" />;
    case 72:
      return <i className="wo_icons wi wi-moon-waxing-gibbous-4" />;
    case 73:
      return <i className="wo_icons wi wi-moon-full" />;
    case 74:
      return <i className="wo_icons wi wi-moon-waning-gibbous-5" />;
    case 75:
      return <i className="wo_icons wi wi-moon-waning-crescent-4" />;
    case 76:
      return <i className="wo_icons wi wi-night-alt-cloudy" />;
    case 77:
      return <i className="wo_icons wi wi-night-partly-cloudy" />;
    case 80:
      return <i className="wo_icons wi wi-strong-wind" />;
    case 81:
      return <i className="wo_icons wi wi-humidity wi-dry" />;
    case 82:
      return <i className="wo_icons wi wi-humidity wi-wet" />;
    case 83:
      return <i className="wo_icons wi wi-fog" />;
    case 84:
      return <i className="wo_icons wi wi-fog" />;
    case 85:
      return <i className="wo_icons wi wi-dust" />;
    case 90:
      return <i className="wo_icons wi wi-hot" />;
    case 91:
      return <RiArrowRightUpLine />;
    //return <i className="wo_icons_arrow wo_icons wi wi-direction-up-right" />
    case 92:
      return <RiArrowRightDownLine />;
    //return <i className="wo_icons_arrow wo_icons wi wi-direction-down-right" />
    case 93:
      return <i className="wo_icons wi wi-snowflake-cold" />;
    default:
      return null;
    // return <DayCloudy/>
  }
}

const weatherOutlookBox = (item: weatherOutlookArrayItem) => {
  return (
    <div className="weatherOutlookBox_Content" key={item?.outlookDay}>
      <div className="weatherOutlookBox_Date">
        {item?.outlookMonth}月{item?.outlookDay}日(
        {item?.outlookWeek})
      </div>
      <div className="weatherOutlookBox_Icon">
        {WeatherIcon(item?.outlookID)}
      </div>
      <div>
        {item?.outlookWind}
        {item?.outlookWeather}
      </div>
      <div>
        溫度：{item?.outlookMinTemp}-{item?.outlookMaxTemp}℃
      </div>
      <div>
        濕度：{item?.outlookMinHum}-{item?.outlookMaxHum}%
      </div>
      <div>顯著降雨機會：{item?.outlookPSR}</div>
    </div>
  );
};
//#endregion

function WeatherOutlook() {
  const [forecastTime, setForecastTime] = useState<string>("");
  const [weatherOutlook, setWeatherOutlook] =
    useState<Array<weatherOutlookArrayItem>>();

  async function getFetchForcastInfomation() {
    await getWeatherOutlook()
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        let tempWeatherOutlook: Array<weatherOutlookArrayItem> = [];
        data?.weatherForecast?.map((item: any) => {
          return tempWeatherOutlook.push({
            outlookID: item?.ForecastIcon,
            outlookMonth: item?.forecastDate.substr(4, 2),
            outlookDay: item?.forecastDate.substr(6, 2),
            outlookWeek: item?.week,
            outlookMaxTemp: item?.forecastMaxtemp.value,
            outlookMinTemp: item?.forecastMintemp.value,
            outlookMaxHum: item?.forecastMaxrh.value,
            outlookMinHum: item?.forecastMinrh.value,
            outlookWeather: item?.forecastWeather,
            outlookWind: item?.forecastWind,
            outlookPSR: item?.PSR,
          });
        });

        let updateTimeObject: string = data.updateTime.substr(11, 5);

        setWeatherOutlook(tempWeatherOutlook.slice(0, 3));
        setForecastTime(updateTimeObject);
      });
  }

  useEffect(() => {
    getFetchForcastInfomation();
  }, []);

  return (
    <div>
      <Container>
        <div id="weatherOutlookBox">
          <div id="weatherOutlookBox_Title">三天預報(天文台)</div>

          <div>
            {weatherOutlook?.map((item) => {
              return weatherOutlookBox(item);
            })}
          </div>

          <div
            id="weatherOutlookBox_Content_time"
            className="weatherOutlookBox_Content"
          >
            {forecastTime}更新
          </div>
        </div>
      </Container>
    </div>
  );
}

export default WeatherOutlook;
